// RenameFolderFileModal.jsx
import React, { useState, useEffect } from "react";
import { Modal, IconButton, TextField } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
import { mySpaceRenameAndMoveFolderFile } from "../../utils/api/mySpaceApi";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as CrossIcon } from "../../assets/images/crossIconAdvancedFilter.svg";

const RenameFolderFileModal = ({ open, onClose, onSuccess = () => {}, initialName = "", headerText = "" }) => {
  const [newName, setNewName] = useState(initialName);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setNewName(initialName); // Reset when modal opens
  }, [open, initialName]);

  const handleRename = async () => {
    try {
      setIsLoading(true);
      const response = await mySpaceRenameAndMoveFolderFile({
        body: { name: newName },
        params: { "folder-file-id": open?.id || null },
      });
      if (response?.success) {
        onSuccess(open?.owner_id);
        onClose();
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message, visible: true }));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} className="flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md relative">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-300">
          <h2 className="text-xl text-[#434852]">Rename {headerText}</h2>
          {/* <IconButton onClick={onClose} size="small"> */}
          <CrossIcon onClick={onClose} className="text-[#C9CDD7] cursor-pointer" />
          {/* </IconButton> */}
        </div>

        {/* Body */}
        <div className=" flex flex-col text-[#434852] gap-2 p-4">
          {headerText} Name
          <input
            fullWidth
            label="New name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            autoFocus
            className="border rounded-md p-4 w-full"
            maxLength={20}
          />
        </div>

        {/* Footer */}
        <div className="flex justify-end items-center gap-2 m-0 px-4 pb-6">
          <Button
            className="rounded-md"
            style={{ padding: "8px 16px" }}
            size="small"
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            isLoading={isLoading}
            className="rounded-md"
            style={{ padding: "8px 16px" }}
            size="small"
            variant="primary"
            onClick={handleRename}
            isDisabled={!newName.trim()}
          >
            Rename
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RenameFolderFileModal;
